import React, {Fragment} from "react";


import PageSkeleton from "../components/ui/pageskeleton.js";
import { DateRangeProvider } from "../components/ui/date-range-picker.js";
import {useGetCaseCategories} from '../api/categories.js';
import CategoryReviewReport from "../components/ui/report-transaction-category-review.js";
import {TransactionReviewProvider} from "../components/ui/transaction-review-context.js";
import { useGetTransactions } from "../api/transactions.js";
import CurrentCaseRequired from "../components/ui/current-case-required.js";
import CaseDatabaseCheck from "../components/ui/case-database-check.js";



function ReviewStatementCategorizationView(props) {
    const subcategoryQueryResult = useGetCaseCategories()
    const subcategory_options = subcategoryQueryResult.data ? subcategoryQueryResult.data : []
    const transactionResult = useGetTransactions()

    const data = transactionResult.data

    const date_field = 'posting_date';

    const handleCategoryRuleCreate = async (transaction) => {
        console.warn(`in handleCategoryRuleCreate, function does not do anything`)
    }

    const handleFlagRuleCreate = async (transaction) => {
        console.warn(`in handleFlagRuleCreate, function does not do anything`)
    }

    if(transactionResult.isLoading || subcategoryQueryResult.isLoading || !data){
      return (
          <PageSkeleton />
      );
    }


    return (
        <Fragment>
          <DateRangeProvider {...props} data={data} date_field={date_field}>
            <TransactionReviewProvider>
              <CategoryReviewReport
                {...props}
                data={data}
                date_field={date_field}
                subcategory_options={subcategory_options}
                handleCategoryRuleCreate={handleCategoryRuleCreate}
                handleFlagRuleCreate={handleFlagRuleCreate}
                />
            </TransactionReviewProvider>
          </DateRangeProvider>
          </Fragment>
      );
    }


  export default function ReviewStatementCategorization(props) {
  return (
    <CaseDatabaseCheck>
    <CurrentCaseRequired>
      <ReviewStatementCategorizationView {...props} />
    </CurrentCaseRequired>
    </CaseDatabaseCheck>
  );
    }